import { ANIMATION_STATE } from "../consts";
class IdleState {
    name;
    animationController;
    /** The idle state, mostly used as default for most characters. */
    constructor(animationController) {
        this.name = ANIMATION_STATE.IDLE;
        this.animationController = animationController;
    }
    /**
     * Enter the idle state. Handle interpolation between different states.
     * @param previousState The state from which we entered. If none is provded, the animation is just played normally.
     */
    enter(previousState) {
        const idleAction = this.animationController.getAnimations[this.name].action;
        if (!previousState) {
            idleAction.play();
            return;
        }
        const previousAction = this.animationController.getAnimations[previousState.name].action;
        idleAction.time = 0.0;
        idleAction.enabled = true;
        idleAction.setEffectiveTimeScale(1.0);
        idleAction.setEffectiveWeight(1.0);
        idleAction.crossFadeFrom(previousAction, 0.5, true);
        idleAction.play();
    }
    /**
     * Exit the idle state.
     */
    exit() { }
    /**
     * Perform an update on the idle state
     * @param deltaTime The current value of the delta timer.
     * @param input A character controller input.
     * @param setState A function that changes the states of the finite state machine.
     */
    update(deltaTime, input, setState) {
        if (input.getFORWARD || input.getBACK) {
            setState(ANIMATION_STATE.WALK);
        }
    }
}
export { IdleState };
